/* eslint-disable camelcase */
export enum CreateSaleTypes {
  GET_CREATE_SALE_REQUEST = '@create_sale/GET_CREATE_SALE_REQUEST',
  GET_CREATE_SALE_SUCCESS = '@create_sale/GET_CREATE_SALE_SUCCESS',
  GET_CREATE_SALE_FAILURE = '@create_sale/GET_CREATE_SALE_FAILURE',
}

export interface ServiceTypes {
  id: number;
  nome: string;
}

export interface CreateSalesTypes {
  venda: {
    cliente_id: number;
    contato_cliente_id: number;
    created_at: string;
    data_cancelamento: null;
    data_vencimento: string;
    formas_pagamento_id: string;
    from_site: number;
    id: number;
    motivo_cancelamento_id: null;
    observacao: string;
    parcelas: number;
    recompra: number;
    renovacao_automatica: number;
    status_carrinho_id: number;
    status_id: number;
    tipo_venda_id: number;
    updated_at: string;
    usuario_criacao_id: number;
    usuario_modificacao_id: number;
    valor_adicional: string;
    valor_base: string;
    valor_desconto_negociacao: string;
    valor_total: string;
    valor_variacao_forma_pagamento: string;
  };
}

export interface CreateSaleDadosTypes {
  sale: CreateSalesTypes;
  vigencia_fim: string | null;
  vigencia_inicio: string | null;
  services_name: Array<ServiceTypes>;
  return_code: number | null;
  is_charged: boolean;
  display: string;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface CreateSaleState {
  create_sale: CreateSaleDadosTypes;
  readonly requestCreate: RequestState;
}
